import { PATH } from 'constants/path';

export const replacePath = (path: string, searchValue: string, replaceValue: string) => {
  return path.replace(searchValue, replaceValue);
};

export const getClassPath = (id: string, path: string) => {
  return `${PATH.CLASSES}/${PATH.CLASSES_DETAIL.replace(':id', id)}/${path}`;
};
